import { createContext, useContext, type ReactNode } from 'react';
import type { BannerTypes } from './Banner.types.js';

type BannerContextType = {
  variant: BannerTypes;
};

const BannerContext = createContext<BannerContextType | undefined>(undefined);

interface BannerProviderProps {
  children: ReactNode;
  value: BannerContextType;
}

const BannerProvider = ({ children, value }: BannerProviderProps) => {
  return (
    <BannerContext.Provider value={value}>{children}</BannerContext.Provider>
  );
};

const useBanner = (): BannerContextType => {
  const context = useContext(BannerContext);

  if (context === undefined) {
    throw new Error('useBanner must be used within a BannerProvider');
  }

  return context;
};

export { BannerProvider, useBanner };
